<template>
  <div>
    <el-container style="height: 100vh; border: 0px solid #eee">
      <!-- PC侧边导航 -->
      <el-aside
        v-if="$route.name != 'login'"
        width="250px"
        style="background-color: #333"
        class="hidden-xs-only"
      >
        <el-menu
          :default-active="$route.name"
          class="el-menu-vertical-demo"
          background-color="#333"
          text-color="#fff"
          active-text-color="#ffd04b"
          :router="true"

        >
          <el-menu-item
            v-for="(item, index) in menu"
            :key="index"
            :index="item.name"
            @click="menuClick({ name: item.name, label: item.label })"
            v-if="item.child.length == 0"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu
            v-for="(item, index) in menu"
            :index="item.label"
            :key="index"
            v-if="item.child.length != 0"
          >
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>{{ item.label }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                style="text-indent:2em;"
                v-for="(item2, index2) in item.child"
                @click="menuClick({ name: item2.name, label: item2.label })"
                :key="index2"
                :index="item2.name"
                >{{ item2.label }}</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- PC侧边导航 -->
      <!-- 主体 -->
      <el-container>
        <!-- 头部 -->
        <el-header
          v-if="$route.name != 'login'"
          class="el-header"
        >
          <!-- H5导航菜单 -->
          <el-menu
            :default-active="$route.name"
            class="el-menu-vertical-demo h5menu"
            background-color="#3c3c3c"
            text-color="#fff"
            active-text-color="#ffd04b"
            :router="true"
            mode="horizontal"
            :unique-opened='true'
            menu-trigger='click'
          >
            <el-submenu index="null">
              <template slot="title">
                <i class="el-icon-s-unfold" style="font-size:30px;"></i>
                <!-- <span>菜单</span> -->
              </template>

              <!-- 单层菜单 -->
              <el-menu-item
                v-for="(item, index) in menu"
                :index="item.name"
                :key="index"
                @click="menuClick({ name: item.name, label: item.label })"
                v-if="item.child.length == 0"
              >
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>
              <!-- 单层菜单 -->

              <!-- 多层菜单 -->
              <el-submenu
                v-for="(item, index) in menu"
                :index="item.label"
                :key="index"
                v-if="item.child.length != 0"
              >
                <template slot="title">
                  <span>{{ item.label }}</span>
                </template>
                <el-menu-item
                  v-for="(item2, index2) in item.child"
                  :index="item2.name"
                  :key="index2"
                  @click="menuClick({ name: item2.name, label: item2.label })"
                  >{{ item2.label }}</el-menu-item
                >
              </el-submenu>
              <!-- 多层菜单 -->

            </el-submenu>
          </el-menu>
          <!-- H5导航菜单 -->
          <!-- 账户余额与授信 -->
          <div class="account">
            <div>
              余额：<span class="yellow"
                >￥{{ this.$mStore.state.account.user_money }}</span
              >
            </div>
            <div>
              授信：<span class="yellow"
                >￥{{ this.$mStore.state.account.user_credit }}</span
              >
            </div>
             <div>
              剩余短信条数：<span class="yellow"
                >{{ this.$mStore.state.account.user_sms }}</span
              >
            </div>
          </div>
          <!-- 账户余额与授信 -->
          <!-- 头像信息 -->
          <el-dropdown
            trigger="click"
            size="medium"
            style="float:right;"
            @command="handleCommand"
          >
            <div class="NameOrCover">
              <span class="loginName">{{
                this.$mStore.state.headerCoverData.title
              }}</span>
              <div class="loginCover">
                <img
                  v-if="this.$mStore.state.headerCoverData.cover"
                  :src="this.$mStore.state.headerCoverData.cover"
                  alt="头像"
                />
                <img v-else src="./assets/头像.png" alt="" />
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="personal">个人信息</el-dropdown-item>
              <el-dropdown-item command="up_password"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item command="logout" divided
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 头像信息 -->

        </el-header>
        <!-- 头部 -->

        <!-- 动态导航条 -->
        <commonTab
          class="commontab"
          v-if="$route.name != 'login'"
        ></commonTab>
        <!-- 动态导航条 -->

        <!-- router-view -->
        <el-main :class="this.$route.name == 'login' ? 'pd0' : 'Appmain'">
          <router-view />
        </el-main>
        <!-- router-view -->

      </el-container>
      <!-- 主体 -->
    </el-container>
    <!-- 弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="UpModal"
      :before-close="clearUpModal"
      :close-on-click-modal="false"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-position="left"
      >
        <el-form-item
          label="原密码"
          prop="passwd"
          :label-width="formLabelWidth"
        >
          <el-input type="password" v-model="ruleForm.passwd"></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="passwd_new"
          :label-width="formLabelWidth"
        >
          <el-input type="password" v-model="ruleForm.passwd_new"></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="passwd_repetition"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="ruleForm.passwd_repetition"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="success" @click="isUpload">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 -->
    <!-- 弹窗 -->
    <el-dialog
      title="个人信息"
      :visible.sync="detailModal"
      :before-close="clearModal"
      :close-on-click-modal="false"
    >
      <el-form ref="formData" :model="formData" label-position="left">
        <el-form-item
          label="上传头像"
          prop="cover"
          :rules="[
            {
              required: true,
              message: '请上传头像！',
              trigger: ['blur', 'change'],
            },
          ]"
          :label-width="formLabelWidth"
        >
          <el-upload
            :limit="1"
            ref="upload"
            action=""
            :before-upload="beforeUpload"
            list-type="picture-card"
            :http-request="upload"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <!-- <el-form-item label="商户名称"
          prop="title"
          :rules="[
            {
              required: true,
              message: '请输入商户名称！',
              trigger:  ['blur','change'],
            },
          ]"
         :label-width="formLabelWidth">
          <el-input v-model="formData.title"></el-input>
        </el-form-item> -->
        <el-form-item
          label="手机号"
          prop="mobile"
          :rules="[
            {
              required: true,
              message: '请输入手机号！',
              trigger: ['blur', 'change'],
            },
            {
              pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
              message: '请输入正确的手机号！',
              trigger: ['blur', 'change'],
            },
          ]"
          :label-width="formLabelWidth"
        >
          <el-input v-model="formData.mobile"></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="[
            { required: true, message: '请输入邮箱！', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱！',
              trigger: ['blur', 'change'],
            },
          ]"
          :label-width="formLabelWidth"
        >
          <el-input v-model="formData.email"></el-input>
        </el-form-item>
        <!-- <el-form-item label="地址"
          prop="address_name"
          :rules="[
            {
              required: true,
              message: '请输入地址！',
              trigger:  ['blur','change'],
            },
          ]"
         :label-width="formLabelWidth">
          <el-input v-model="formData.address_name"></el-input>
        </el-form-item> -->
        <el-form-item
          label="详细地址"
          prop="address_details"
          :rules="[
            {
              required: true,
              message: '请输入详细地址！',
              trigger: ['blur', 'change'],
            },
          ]"
          :label-width="formLabelWidth"
        >
          <el-input v-model="formData.address_details"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="success" @click="isSubmit">修 改</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mallRequest } from '@/components/utils/ticket.js'
import commonTab from '@/components/common/commonTab'
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码！'))
      } else {
        if (this.ruleForm.passwd_repetition !== '') {
          this.$refs.ruleForm.validateField('passwd_repetition')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码！'))
      } else if (value !== this.ruleForm.passwd_new) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      content: {},
      oldWindowWidth: 0,
      currentMenu: this.$mStore.state.currentMenu,
      menu: [
        {
          name: 'home',
          label: '首页',
          child: []
        },
        {
          name: null,
          label: '产品订购',
          child: [
            {
              name: 'ticket',
              label: '门票预订'
            },
            {
              name: 'order',
              label: '订单列表'
            }
            // {
            //   name: 'orderReport',
            //   label: '订单报表',
            // },
          ]
        },
        {
          name: null,
          label: '充值提现',
          child: [
            {
              name: 'repayment',
              label: '授信还款管理'
            },
            {
              name: 'creditDetails',
              label: '授信变动明细'
            }
          ]
        }
      ],
      loginData: {},
      formData: {
        email: '',
        address_name: '',
        address_details: '',
        mobile: '',
        cover: ''
      },
      UpModal: false,
      detailModal: false,
      formLabelWidth: '100px',
      file: '',
      uploadData: {},
      fileList: [],
      ruleForm: {
        passwd: '',
        passwd_new: '',
        passwd_repetition: ''
      },
      rules: {
        passwd: [
          {
            required: true,
            message: '请输入原密码！',
            trigger: ['blur', 'change']
          }
        ],
        passwd_new: [
          {
            required: true,
            validator: validatePass,
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: ['blur', 'change']
          }
        ],
        passwd_repetition: [
          {
            required: true,
            validator: validatePass2,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  created () {
    if (localStorage.getItem('headerCoverData')) {
      this.$mStore.state.headerCoverData = JSON.parse(
        localStorage.getItem('headerCoverData')
      )
    }
    if (localStorage.getItem('FXaccount')) {
      this.$mStore.state.account = JSON.parse(
        localStorage.getItem('FXaccount')
      )
    }
    if (this.$route.name != 'login') {
      this.$mStore.dispatch('zhanghu')
    }
  },
  mounted () {
    // setTimeout(() => {
    //   console.log('%c⧭', 'color: #994d75', this.$route)
    //   if(this.$route.name&&this.$route.meta.label){
    //     this.$mStore.commit('selectMenu', {name:this.$route.name,label:this.$route.meta.label});
    //   }
    // }, 10000);
    this.oldWindowWidth = window.innerWidth
    this.onResize(window)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize (e) {
      const target = e.target || e
      // const table = this.$refs.table
      if (this.oldWindowWidth <= 480 && target.innerWidth > 480) {
        // this.$nextTick(() => {
        //   table && table.doLayout()
        // })
      } else if (
        (this.oldWindowWidth > 480 && target.innerWidth <= 480) ||
        (this.oldWindowWidth <= 480 && target.innerWidth <= 480)
      ) {
        console.log('pc => h5')
        // this.$nextTick(() => {
        //   table && table.doLayout()
        // })
      }
      this.oldWindowWidth = target.innerWidth
    },
    isSubmit (done) {
      this.$refs['formData'].validate((valid) => {
        // 验证
        if (valid) {
          this.$confirm('确认提交？')
            .then((_) => {
              this.submit()
            })
            .catch((_) => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submit () {
      console.log(this.formData)
      mallRequest({
        apiName: 'distribution_personal',
        method: 'post',
        data: this.formData
      })
        .then((res) => {
          console.log(res)
          if (res && res.code == 200) {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getLoginMsg()
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    handleChange (file, fileList) {
      console.log('%c⧭', 'color: #733d00', fileList)
      if (fileList.length == 1) {
        this.$refs.upload.$children[1].$el.style = 'display:none;'
      }
    },
    clearModal () {
      this.detailModal = false
      this.$refs.upload.clearFiles()
      this.file = ''
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields() // 重置提示信息
      }
    },
    beforeUpload (file) {
      this.file = file

      // console.log('%cbeforeUpload', 'color: #00a3cc',  file)
    },
    handleRemove (file, fileList) {
      this.formData.cover = ''
      if (fileList.length == 0) {
        this.$refs.upload.$children[1].$el.style = 'display:inline-block;'
      }
    },
    upload () {
      this.$base64Img(this.file, (img) => {
        this.uploadData['image'] = img.split(',')[1]
        this.uploadData['extend'] = this.file.name.split('.')[1]
        // 上传图片
        mallRequest({
          apiName: 'uploadimg',
          method: 'post',
          data: this.uploadData
        })
          .then((res) => {
            console.log(res)
            if (res && res.code == 200) {
              this.formData.cover = res.data.url
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          })
          .catch((e) => {
            console.log(e)
          })
      })
    },
    handleCommand (command) {
      if (command == 'personal') {
        this.personal()
      } else if (command == 'logout') {
        this.logout()
      } else if (command == 'up_password') {
        this.up_password()
      }
    },
    isUpload (done) {
      this.$refs['ruleForm'].validate((valid) => {
        // 验证
        if (valid) {
          this.$confirm('确认提交？')
            .then((_) => {
              this.uploadPs()
            })
            .catch((_) => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    uploadPs () {
      mallRequest({
        apiName: 'up_password',
        method: 'post',
        data: this.ruleForm
      })
        .then((res) => {
          console.log(res)
          if (res && res.code == 200) {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.clearUpModal()
            this.logout(false)
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    up_password () {
      this.UpModal = true
    },
    clearUpModal () {
      this.UpModal = false
      this.ruleForm = {
        passwd: '',
        passwd_new: '',
        passwd_repetition: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    personal () {
      this.detailModal = true
      this.getLoginMsg(1)
    },
    menuClick (tab) {
      this.$mStore.commit('selectMenu', tab)
    },
    getLoginMsg (type) {
      mallRequest({
        apiName: 'distribution_info',
        method: 'post',
        data: {}
      })
        .then((res) => {
          console.log(res)
          if (res && res.code == 200) {
            this.formData = res.data
            if (type == 1) {
              if (this.$mStore.state.headerCoverData.cover != '') {
                this.fileList = [
                  { url: this.$mStore.state.headerCoverData.cover }
                ]
              }
              this.handleChange(this.file, this.fileList)
            } else {
              localStorage.setItem('headerCoverData', JSON.stringify(res.data))
              this.$mStore.state.headerCoverData = res.data
              this.clearModal()
            }
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    logout (type = true) {
      mallRequest({
        apiName: 'logout',
        method: 'get',
        data: {}
      })
        .then((res) => {
          console.log(res)
          if (res && res.code == 200) {
            if (type) {
              this.$message({
                message: res.message,
                type: 'success'
              })
            }
            this.$router.push({ path: '/login' })
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }
  },
  components: {
    commonTab
  }
}
</script>
<style>
*::-webkit-scrollbar{
  display: none;
}
.yellow {
  margin: 0 10px 0 0;
  color: rgb(238, 255, 5);
}
.account {
  float: left;
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #fff;
}

.NameOrCover {
  height: 60px;
  display: flex;
  float: right;
  align-items: center;
  padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.5s;
}
.NameOrCover:hover {
  background: #222;
}
.loginName {
  font-size: 14px;
  color: #f2f2f2;
}
.loginCover {
  width: 50px;
  height: 50px;
  /* border: 2px solid #fff; */
  box-sizing: border-box;
  border-radius: 25px;
  margin-left: 20px;
  overflow: hidden;
}
.loginCover img {
  width: 100%;
  height: 100%;
}
.el-header {
  background: #3c3c3c;
}
.el-menu {
  border: none;
}
.el-aside {
  color: #333;
}
.Appmain {
  padding:0 10px !important;
  margin-top:34px;
}
.pd0 {
  padding: 0 !important;
}
.h5menu{
  display: none;
}
.commontab{
  width: 100%;
  position: absolute;
  top: 60px;
}

@media screen and (max-width: 480px) {
  .el-submenu__title {
    border: 0 !important;
  }
  .el-message{
    min-width:80% !important;
  }
  .el-dialog{
    width: 96% !important;
  }
  .el-header{
    padding: 0 !important;
  }
  .h5menu{
    float: left;
    display: block;
  }
  .account {
    display: flex;
    justify-content: center;
    flex-direction: column;
    line-height: 25px;
    font-size: 12px;
  }
  .account > div {
    height: 25px;
  }
  .el-message-box{
    width:96%  !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue